import { useEffect } from 'react';

function EngagementTimer({
  updateActiveSecondsRef,
  resetTimer
}) {

  let inactivityTimer;
  let timerIsPaused = false;

  const IDLE_THRESHOLD = 5000; // 5 seconds (adjust as needed)

  // Reset timer when resetTimer is triggered
  useEffect(() => {
    if (resetTimer) {
      updateActiveSecondsRef.current = 0;
      clearTimeout(inactivityTimer);
      timerIsPaused = false;
      startTimer();
    }
  }, [resetTimer, updateActiveSecondsRef]);

  const startTimer = () => {
    inactivityTimer = setTimeout(() => {
      timerIsPaused = true;
    }, IDLE_THRESHOLD);
  };

  const handleActivity = () => {
    if (timerIsPaused) {
      timerIsPaused = false;
      startTimer();
    } else {
      clearTimeout(inactivityTimer);
      startTimer();
    }
  };

  const handleVisibilityChange = () => {
    if (document.hidden) {
      timerIsPaused = true;
      clearTimeout(inactivityTimer);
    } else {
      timerIsPaused = false;
      startTimer();
    }
  };

  // Increment active seconds every second using setInterval
  useEffect(() => {
    const intervalId = setInterval(() => {
      if (!timerIsPaused) {
        updateActiveSecondsRef.current += 1;
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, [timerIsPaused, updateActiveSecondsRef]);

  // Listen for user activity and visibility changes
  useEffect(() => {
    const activityEvents = ['load', 'mousedown', 'touchstart', 'click', 'keypress', 'mousemove', 'keydown'];

    activityEvents.forEach(eventType => {
      document.addEventListener(eventType, handleActivity);
    });

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      activityEvents.forEach(eventType => {
        document.removeEventListener(eventType, handleActivity);
      });
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      clearTimeout(inactivityTimer);
    };
  }, []);

  // Start the timer when the component mounts
  useEffect(() => {
    startTimer();
    return () => clearTimeout(inactivityTimer);
  }, []);

  return null; // Display nothing
}

export default EngagementTimer;
